import { z } from "zod";

export const ecoDrivingScoreUnder30PayloadSchema = z.object({
  vin: z.string(),
  startDateTime: z.string(),
  endDateTime: z.string(),
  companyUuid: z.string(),
  vehicleUuid: z.string(),
  ecoDrivingScore: z.number(),
});

export type EcoDrivingScoreUnder30Payload = z.infer<
  typeof ecoDrivingScoreUnder30PayloadSchema
>;
